import type { IIntentDistributionChartData } from "app/pages/keyword-research/common-components/intent-distribution-chart/intentDistributionChartTypes";

export const getDominantIntent = (data: IIntentDistributionChartData): string => {
    return Object.keys(data).reduce((a, b) => (data[a] > data[b] ? a : b), "");
};
